import React from 'react';

export default function Alert(props) {
    const capitalize = (word) => {
        const lower = word.toLowerCase();
        return lower.charAt(0).toUpperCase() + lower.slice(1);
    }
    return (
        <div style={{ height: '50px' }}>
            {
                props.alert && <div className={`alert alert-${props.alert.type} alert-dismissible fade show`} role="alert">
                    <strong>{capitalize(props.alert.type)}</strong> : {props.alert.msg}
                </div>
            }
        </div>


        // we r using props.alert kyuki
        // humne alert ki default value null pass ki hui hai isliye
        // agar props.alert is null then div wala poora won't be evaluated 
        // agar props.alert is not null then div wala poora will be evaluated 

        // This happens because all the JSX will be converted to JS calls 
    )
}
